<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <div class="main-content">
        <div style="margin: 5px;">
            <div class="main-heading">
                <h1>User Registration Form</h1>
            </div>
            <form (ngSubmit)="submitForm()" #registrationForm="ngForm" class="registration-form">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="full_name">Full Name:</label>
                            <input type="text" class="form-control" id="full_name" name="full_name"
                                [(ngModel)]="formData.full_name" required>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="email">Email:</label>
                            <input type="email" class="form-control" id="email" name="email"
                                [(ngModel)]="formData.email" required>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group widthadded">
                            <label for="company_name">Company Name:</label>
                            <div>
                                <p-dropdown id="company_name" [options]="sourceDropdownOptions" style="width: 100%;"
                                    [ngModelOptions]="{standalone: true}" (onChange)="dropdownchange($event)"
                                    [(ngModel)]="formData.company_name">
                                </p-dropdown>
                            </div>
                            <!-- <input type="text" class="form-control" id="company_name" name="company_name" [(ngModel)]="formData.company_name"
                                 required> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="category">Category:</label>
                            <select class="form-control" id="category" name="category" [(ngModel)]="formData.category"
                                required>
                                <option value="">Select Category</option>
                                <option value="SILVER">SILVER</option>
                                <option value="GOLD">GOLD</option>
                                <option value="PLATINUM">PLATINUM</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="currency">Currency:</label>
                            <input type="text" class="form-control" id="currency" name="currency"
                                [(ngModel)]="formData.currency" required [disabled]="true">
                            <!-- <select class="form-control" id="currency" name="currency" [(ngModel)]="formData.currency"
                                required [disabled]="true">
                                <option value="">Select Category</option>
                                <option value="USD">USD</option>
                                <option value="Indian Rupee">Indian Rupee</option>
                            </select> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="period_returns">Period of calculating returns: (years)</label>
                            <input type="number" class="form-control" id="period_returns" name="period_returns"
                                [(ngModel)]="formData.period_returns" required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="period_returns" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="tax_rate">Tax Rate: (%)</label>
                            <input type="number" class="form-control" id="tax_rate" name="tax_rate"
                                [(ngModel)]="formData.tax_rate" required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="tax_rate" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="depreciation">Depreciation: (years)</label>
                            <input type="number" class="form-control" id="depreciation" name="depreciation"
                                [(ngModel)]="formData.depreciation" required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="depreciation" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="sg_a">SG&A: (%)</label>
                            <input type="number" class="form-control" id="sg_a" name="sg_a" [(ngModel)]="formData.sg_a"
                                required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="sg_a" inputId="minmaxfraction" mode="decimal"
                                [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="logistics_insurance">Logistic & Insurance: (%)</label>
                            <input type="number" class="form-control" id="logistics_insurance"
                                name="logistics_insurance" [(ngModel)]="formData.logistics_insurance" required
                                [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="logistics_insurance" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="market_share">Market share: (%)</label>
                            <input type="number" class="form-control" id="market_share" name="market_share"
                                [(ngModel)]="formData.market_share" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="market_share" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="amortisation">Amortisation: (years)</label>
                            <input type="number" class="form-control" id="amortisation" name="amortisation"
                                [(ngModel)]="formData.amortisation" required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="amortisation" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="rebates_discount">Rebate & Discount: (%)</label>
                            <input type="number" class="form-control" id="rebates_discount" name="rebates_discount"
                                [(ngModel)]="formData.rebates_discount" required [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="rebates_discount" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="solid_oral_healthy">Solid oral & Healthy: (months)</label>
                            <input type="number" class="form-control" id="solid_oral_healthy" name="solid_oral_healthy"
                                [(ngModel)]="formData.solid_oral_healthy" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="solid_oral_healthy" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="solid_oral_patient">Solid oral & Patient: (months)</label>
                            <input type="number" class="form-control" id="solid_oral_patient" name="solid_oral_patient"
                                [(ngModel)]="formData.solid_oral_patient" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="solid_oral_patient" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="injectables_waiver">Injectable (Waiver): (months)</label>
                            <input type="number" class="form-control" id="injectables_waiver" name="injectables_waiver"
                                [(ngModel)]="formData.injectables_waiver" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="injectables_waiver" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="injectables_pk">Injectable (With PK / Patient BE study): (months)</label>
                            <input type="number" class="form-control" id="injectables_pk" name="injectables_pk"
                                [(ngModel)]="formData.injectables_pk" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="injectables_pk" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="topical">Topical: (months)</label>
                            <input type="number" class="form-control" id="topical" name="topical"
                                [(ngModel)]="formData.topical" [disabled]="true">
                            <!-- <p-inputNumber class="numberOnly" [(ngModel)]="topical" inputId="minmaxfraction"
                                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="inhalation">Inhalation: (months)</label>
                            <input type="number" class="form-control" id="inhalation" name="inhalation"
                                [(ngModel)]="formData.inhalation" [disabled]="true">
                        </div>
                    </div>

                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Products:</label>
                            <div class="d-flex align-items-start gap-3">

                                <div style="width: 300px; flex-shrink: 0;">
                                    <p-multiSelect [options]="productOptions" [(ngModel)]="selectedProducts"
                                        [ngModelOptions]="{standalone: true}" optionLabel="label" optionValue="value"
                                        [filter]="true" [filterValue]="multiSelectFilter" [resetFilterOnHide]="true"
                                        [virtualScroll]="true" [virtualScrollItemSize]="34"
                                        placeholder="Select Products" [maxSelectedLabels]="0"
                                        selectedItemsLabel="{0} product(s) selected"
                                        (onChange)="onProductSelectionChange($event)"
                                        (onFilter)="onProductSearch($event)" [style]="{'width':'100%'}"
                                        [loading]="productsLoading">
                                    </p-multiSelect>
                                </div>

                                <!-- Selected Tags shown to the right -->
                                <div class="selected-products-box" *ngIf="selectedProducts.length > 0">
                                    <span *ngFor="let product of selectedProducts" class="product-tag">
                                        {{ product }}
                                        <i class="pi pi-times ms-1" style="cursor:pointer; font-size: 11px;"
                                            (click)="removeProduct(product)">
                                        </i>
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="registrationForm.invalid">Submit</button>
            </form>

            <div style="margin-top: 50px;">
                <div class="main-heading">
                    <h1>Registered users</h1>
                </div>
                <div class="card">
                    <p-table #dt [value]="userData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                        [showCurrentPageReport]="true" [globalFilterFields]="['email']"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                                <span class="p-input-icon-left ml-auto">
                                    <input pInputText type="text"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Search by Email" />
                                </span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="full_name">
                                    <span class="header-container">
                                        Name
                                        <p-sortIcon field="full_name"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="company_name">
                                    <span class="header-container">
                                        Company
                                        <p-sortIcon field="company_name"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="category">
                                    <span class="header-container">
                                        Package
                                        <p-sortIcon field="category"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="email">
                                    <span class="header-container">
                                        Email
                                        <p-sortIcon field="email"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="last_login">
                                    <span class="header-container">
                                        Last Login Date
                                        <p-sortIcon field="last_login"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="start_date">
                                    <span class="header-container">
                                        Start Date
                                        <p-sortIcon field="start_date"></p-sortIcon>
                                    </span>
                                </th>
                                <th pSortableColumn="end_date">
                                    <span class="header-container">
                                        Expiry Date
                                        <p-sortIcon field="end_date"></p-sortIcon>
                                    </span>
                                </th>
                                <!-- <th>Name</th>
                                <th>Company</th>
                                <th>Package</th>
                                <th>Email</th>
                                <th>Last Login</th>
                                <th>Start Date</th>
                                <th>End Date</th> -->
                                <th>Status</th>
                                <!-- <th>Actions</th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                            <tr>
                                <td>{{ rowData['full_name'] }}</td>
                                <td>{{ rowData['company_name'] }}</td>
                                <td>{{ rowData['category'] }}</td>
                                <td>{{ rowData['email'] }}</td>
                                <td>{{ rowData['last_login'] | date:'dd/MM/yyyy'}}</td>
                                <td>{{ rowData['start_date'] }}</td>
                                <td>
                                    <ng-container *ngIf="rowData.isEditing">
                                        <p-calendar [(ngModel)]="rowData.end_date" dateFormat="dd/mm/yy"
                                            [showIcon]="true" placeholder="Select Date"
                                            (ngModelChange)="onDateChange($event, rowData, rowIndex)" appendTo="body">
                                        </p-calendar>
                                        <div *ngIf="rowData.dateError" class="text-danger">
                                            {{ rowData.dateError }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!rowData.isEditing">
                                        {{ rowData['end_date'] }}
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="rowData['is_active']">
                                        <button class="btn btn-primary"
                                            (click)="changeUserStatus(rowData, false)">Active</button>
                                    </ng-container>
                                    <ng-container *ngIf="!rowData['is_active']">
                                        <button class="btn btn-secondary"
                                            (click)="changeUserStatus(rowData, true)">Deactive</button>
                                    </ng-container>
                                </td>
                                <!-- <td>
                                    <button class="btn btn-warning" *ngIf="!rowData.isEditing"
                                        (click)="editRow(rowData)">Edit</button>
                                    <button class="btn btn-success" style="margin-right: 4px;" *ngIf="rowData.isEditing"
                                        (click)="saveRow(rowData)">Save</button>
                                    <button class="btn btn-danger" *ngIf="rowData.isEditing"
                                        (click)="cancelEdit(rowData)">Cancel</button>
                                </td> -->
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>